const skillsData = {
  groups: [
    {
      id: 'frontend',
      title: 'Frontend',
      items: [
        'React',
        'Next.js',
        'TypeScript',
        'JavaScript',
        'CSS',
        'SCSS',
        'Tailwind CSS',
      ],
    },
    {
      id: 'backend',
      title: 'Backend',
      items: ['Node.js', 'Express', 'PHP', 'MySQL', 'REST APIs'],
    },
    {
      id: 'tools',
      title: 'Tools',
      items: ['Git', 'WordPress', 'GitHub Copilot', 'Claude Code'],
    },
  ],
};

export default skillsData;
